// /ManufacturingRecord/index.js
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import ManufacturingRecordFilters from "./components/ManufacturingRecordFilters";
import ManufacturingRecordTable from "./components/ManufacturingRecordTable"; // ✅ use correct table
import { fetchManufacturingRecord } from "./ManufacturingRecordThunk";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportManufacturingRecordCsv } from "./components/exportManufacturingRecordCsv";

const { Title } = Typography;

const ManufacturingRecord = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  // 👇 pull data safely (avoid destructuring undefined)
  const manufacturingRecordState = useSelector((state) => state.manufacturingRecord) || {};
  const { filters = {}, list = [] } = manufacturingRecordState;

  useEffect(() => {
    dispatch(fetchManufacturingRecord({})); // initial load
  }, [dispatch]);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Manufacturing Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportManufacturingRecordCsv({
      list,
      filters,
      title:    "Manufacturing Record",
      filename: "manufacturing_record",
    });
  };

  const hasData = list.length > 0; // ← added

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Flex align="center">
              <Button
                type="text"
                icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
                onClick={() => navigate(-1)}
                style={{ marginRight: 8, padding: 0, height: "auto", lineHeight: "1", color: "#000" }}
                data-testid="manufacturing-record-back-button"
              />
              <Title level={4} style={{ margin: 0 }}>Manufacturing Record</Title>
            </Flex>
          }
            extra={
            // ← replaced single Button with Flex + two buttons
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <ManufacturingRecordFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <ManufacturingRecordTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Manufacturing Report"
          mode="report-page"
          filters={filters}
          renderTable={() => <ManufacturingRecordTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default ManufacturingRecord;
